import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getUserStreamState = ({ userSteam }: RootState) => userSteam;

export const userStreamSelector = createSelector([getUserStreamState], (userSteam) => userSteam);
export const earningSelector = createSelector([getUserStreamState], ({ earning }) => earning);
